import { getLanguage, mapAssetClass, getEndpointOptions, inheritEndpointOptions } from '../../helpers/common.js';
import 'lodash.set';
import { SearchSuggesterStoreModuleFactory } from '../search-suggester/index.module.js';
import { WatchlistSelectorStoreModuleFactory } from '../watchlist-selector/index.module.js';
import { MarketSelectorStoreModuleFactory } from '../market-selector/index.module.js';
import '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import { InstrumentGetByNotationModuleFactory } from '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import { NotationCrossReferenceListByInstrumentModuleFactory } from '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import { WatchlistListModuleFactory } from '../../endpoints/watchlist/list.module.js';
import { WatchlistGetModuleFactory } from '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import { WatchlistPositionCreateModuleFactory } from '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import { WatchlistPositionListModuleFactory } from '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';

var _a, _b, _c, _d, _e, _f, _g, _h;
class WatchlistPositionAddStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultNameType = "name";
    this.nameType = (_d = (_c = (_b = (_a = this.options) == null ? void 0 : _a.instrument) == null ? void 0 : _b.name) == null ? void 0 : _c.type) != null ? _d : this.defaultNameType;
    this.defaultFallbackForNameType = true;
    this.isNameTypeFallbackEnabled = (_h = (_g = (_f = (_e = this.options) == null ? void 0 : _e.instrument) == null ? void 0 : _f.name) == null ? void 0 : _g.fallback) != null ? _h : this.defaultFallbackForNameType;
    this.defaultLanguage = "en";
  }
  getDefaultWatchlistId(payload) {
    if (!payload.defaultWatchlistId) {
      throw new Error("Could not find default watchlist id");
    }
    return payload.defaultWatchlistId;
  }
  getWatchlistGetRequest(id) {
    return { id };
  }
  getWatchlistGetData(payload) {
    var _a2;
    try {
      const defaultWatchlistId = this.getDefaultWatchlistId(payload);
      const request = this.getWatchlistGetRequest(defaultWatchlistId);
      const response = this.getEndpoints().watchlistGet.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getInstrumentGetByNotationRequest(id, payloadLanguage) {
    return { id, _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  getInstrumentGetByNotationData(payload, id) {
    var _a2;
    const request = this.getInstrumentGetByNotationRequest(id, payload.language);
    const response = this.getEndpoints().instrumentGetByNotation.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getWatchlistPosition(payload, id) {
    var _a2, _b2, _c2, _d2;
    const instrumentData = this.getInstrumentGetByNotationData(payload, id);
    const nameFallback = this.isNameTypeFallbackEnabled ? (_a2 = instrumentData == null ? void 0 : instrumentData.name) != null ? _a2 : null : null;
    return {
      id,
      isin: (_b2 = instrumentData == null ? void 0 : instrumentData.isin) != null ? _b2 : null,
      name: (_c2 = instrumentData == null ? void 0 : instrumentData[this.nameType]) != null ? _c2 : nameFallback,
      assetClass: mapAssetClass((_d2 = instrumentData == null ? void 0 : instrumentData.assetClass.code) != null ? _d2 : null)
    };
  }
  getWatchlistPositions(payload) {
    return payload.selectedIds.map((id) => this.getWatchlistPosition(payload, id)).filter((item) => item.name !== null);
  }
  getResponseData(payload) {
    var _a2;
    const watchlistData = this.getWatchlistGetData(payload);
    return {
      positions: this.getWatchlistPositions(payload),
      watchlist: {
        name: (_a2 = watchlistData == null ? void 0 : watchlistData.name) != null ? _a2 : null
      }
    };
  }
  getWatchlistPositionListRequest(id) {
    return { id };
  }
  getWatchlistId(payload) {
    if (!payload.watchlistId) {
      throw new Error("Could not find watchlist id");
    }
    return payload.watchlistId;
  }
  getWatchlistPositionListData(payload) {
    var _a2;
    try {
      const watchlistId = this.getWatchlistId(payload);
      const request = this.getWatchlistPositionListRequest(watchlistId);
      const response = this.getEndpoints().watchlistPositionList.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getValidationError(position) {
    return {
      id: position.notation.id,
      type: "positionExists"
    };
  }
  getValidationErrors(payload) {
    const positionListData = this.getWatchlistPositionListData(payload);
    return (positionListData != null ? positionListData : []).filter((position) => payload.selectedIds.includes(position.notation.id)).map((position) => this.getValidationError(position));
  }
  getResponseMeta(payload) {
    const watchlistListData = this.getWatchlistListData(payload);
    return {
      hasWatchlists: watchlistListData ? watchlistListData.length > 0 : null,
      validationErrors: this.getValidationErrors(payload)
    };
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload),
      meta: this.getResponseMeta(payload)
    };
  }
  async updateWatchlistGet(payload) {
    try {
      const defaultWatchlistId = this.getDefaultWatchlistId(payload);
      const request = this.getWatchlistGetRequest(defaultWatchlistId);
      return this.getEndpoints().watchlistGet.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateWatchlistPositionList(payload) {
    try {
      const watchlistId = this.getWatchlistId(payload);
      const request = this.getWatchlistPositionListRequest(watchlistId);
      return this.getEndpoints().watchlistPositionList.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  getWatchlistPositionCreateRequest(watchlistId, notationId) {
    return {
      data: {
        id: watchlistId,
        notation: {
          id: notationId
        }
      }
    };
  }
  async updateWatchlistPositionCreate(payload, notationId) {
    try {
      const watchlistId = this.getWatchlistId(payload);
      const request = this.getWatchlistPositionCreateRequest(watchlistId, notationId);
      return this.getEndpoints().watchlistPositionCreate.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateComponentsInputs(payload) {
    let isRequestSuccessful = true;
    try {
      switch (payload.action) {
        case "getPositions": {
          if (payload.defaultWatchlistId) {
            await this.updateWatchlistGet(payload);
          }
          if (payload.watchlistId) {
            await this.updateWatchlistPositionList(payload);
          }
          break;
        }
        case "addPositions": {
          await Promise.all(payload.selectedIds.map(async (id) => this.updateWatchlistPositionCreate(payload, id)));
          break;
        }
        default: {
          await Promise.all([this.updateWatchlistList(payload), ...payload.selectedIds.map(async (id) => this.updateInstrumentGetByNotation(payload, id))]);
        }
      }
    } catch (error) {
      this.logger.error(error);
      isRequestSuccessful = false;
    }
    return Promise.resolve(isRequestSuccessful);
  }
  async updateInstrumentGetByNotation(payload, id) {
    const request = this.getInstrumentGetByNotationRequest(id, payload.language);
    return this.getEndpoints().instrumentGetByNotation.updateState(request);
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getEndpoints() {
    var _a2;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      this.endpoints = {
        instrumentGetByNotation: this.getModuleEntity(InstrumentGetByNotationModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentGetByNotation")),
        notationCrossReferenceListByInstrument: this.getModuleEntity(
          NotationCrossReferenceListByInstrumentModuleFactory,
          getEndpointOptions(endpointConfiguration, "notationCrossReferenceListByInstrument")
        ),
        watchlistPositionCreate: this.getModuleEntity(WatchlistPositionCreateModuleFactory, getEndpointOptions(endpointConfiguration, "watchlistPositionCreateModule")),
        watchlistPositionList: this.getModuleEntity(WatchlistPositionListModuleFactory, getEndpointOptions(endpointConfiguration, "watchlistPositionListModule")),
        watchlistGet: this.getModuleEntity(WatchlistGetModuleFactory, getEndpointOptions(endpointConfiguration, "watchlistGetModule")),
        watchlistList: this.getModuleEntity(WatchlistListModuleFactory, getEndpointOptions(endpointConfiguration, "watchlistList"))
      };
    }
    return this.endpoints;
  }
  getDependencies() {
    var _a2, _b2, _c2, _d2;
    if (!this.dependencies) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      this.dependencies = {
        searchSuggester: new SearchSuggesterStoreModuleFactory({
          mdg2Client: this.mdg2Client,
          logger: this.logger,
          store: this.store,
          options: inheritEndpointOptions(endpointConfiguration, (_b2 = this.options) == null ? void 0 : _b2.searchSuggester)
        }),
        watchlistSelector: new WatchlistSelectorStoreModuleFactory({
          mdg2Client: this.mdg2Client,
          logger: this.logger,
          store: this.store,
          options: inheritEndpointOptions(endpointConfiguration, (_c2 = this.options) == null ? void 0 : _c2.selector)
        }),
        marketSelector: new MarketSelectorStoreModuleFactory({
          mdg2Client: this.mdg2Client,
          logger: this.logger,
          store: this.store,
          options: inheritEndpointOptions(endpointConfiguration, (_d2 = this.options) == null ? void 0 : _d2.marketSelector)
        })
      };
    }
    return this.dependencies;
  }
  getWatchlistListRequest(payload) {
    return {};
  }
  getWatchlistListData(payload) {
    var _a2;
    const request = this.getWatchlistListRequest(payload);
    const response = this.getEndpoints().watchlistList.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateWatchlistList(payload) {
    const request = this.getWatchlistListRequest(payload);
    return this.getEndpoints().watchlistList.updateState(request);
  }
}

export { WatchlistPositionAddStoreModuleFactory };
